import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import { Container } from "./styled"

export default function Skills() {
  const { wallace } = useStaticQuery(graphql`
    query {
      wallace: file(relativePath: { eq: "wallace.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1200, maxHeight: 1248) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)
  return (
    <>
      <Container>
        <div className="products-container">
          <div className="row">
            <div className="col-lg-4 mb-3">
              <div class="card">
                <Img
                  className="products-image"
                  fluid={wallace.childImageSharp.fluid}
                  alt="foto"
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}
